
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SalesOrder } from '@/api';
import Helpers from '@/logic/orders/helpers';
import OrderItemList from '@/components/orders/OrderItemList.vue';
import OrderContainerList from '@/components/orders/OrderContainerList.vue';

@Component({
  components: { OrderItemList, OrderContainerList },
})
export default class OrderOverviewTable extends Vue {
  @Prop({ type: Object, default: 0 })
  order!: SalesOrder;

  loading = false;

  Helpers = Helpers;

  get etaActualClass(): any {
    if (!this.order.OriginalEta || !this.order.UpdatedEta) {
      return {};
    }
    return {
      'order-details__eta--early':
        this.order.OriginalEta > this.order.UpdatedEta,
      'order-details__eta--late':
        this.order.OriginalEta < this.order.UpdatedEta,
    };
  }

  async created() {
    if (this.order.Id) {
      try {
        this.loading = true;
        await this.$store.dispatch('order/fetchOrder', this.order.Id);
      } finally {
        this.loading = false;
      }
    }
  }

  async reOrder() {
    this.loading = true;
    try {
      await this.$store.dispatch('order/reOrder', this.order);
      this.$router.push({ name: 'new-order' });
    } finally {
      this.loading = false;
    }
  }
}
